var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['cpu-btn',_vm.disable?'cpu-btn__disable':'',_vm.touchActive?'cpu-btn__hover':''],on:{"touchstart":_vm.onTouchStart,"touchend":_vm.onTouchEnd}},[_vm._v("\n  "+_vm._s(_vm.text)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }